let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b2H1n")).then(() => parcelRequire('jcNrb'));